import { Dialog } from '@reach/dialog'
import * as React from 'react'
import { PlayIcon, PlusIcon } from './icons.tsx'

function VideoEmbed({
	onCloseClick,
	videoSrc,
	title,
}: {
	onCloseClick: React.MouseEventHandler<HTMLButtonElement>
	videoSrc: string
	title: string
}) {
	return (
		<div className="px-5vw fixed inset-0 bg-black">
			<button
				aria-label="close video"
				onClick={onCloseClick}
				className="absolute top-8 right-4 z-50 rotate-45 transform text-white hover:scale-150 focus:scale-150 focus:outline-none"
			>
				<PlusIcon />
			</button>
			<div className="flex h-full w-full flex-col justify-center">
				<video
					className="mx-auto max-h-[85vh] w-full max-w-5xl"
					controls
					autoPlay
					playsInline
					src={videoSrc}
					title={title}
				>
					<track kind="captions" />
				</video>
			</div>
		</div>
	)
}

function FullScreenVideoEmbed({
	posterSrc,
	posterAlt,
	videoSrc,
	title,
	autoplay = false,
}: {
	posterSrc: string
	posterAlt: string
	videoSrc: string
	title: string
	autoplay?: boolean
}) {
	const [showPlayer, setShowPlayer] = React.useState(autoplay)
	return (
		<>
			<Dialog
				isOpen={showPlayer}
				onDismiss={() => setShowPlayer(false)}
				aria-label={`Watch ${title}`}
			>
				<VideoEmbed
					onCloseClick={() => setShowPlayer(false)}
					videoSrc={videoSrc}
					title={title}
				/>
			</Dialog>

			{showPlayer ? null : (
				<button
					className="group relative w-full"
					onClick={() => setShowPlayer(true)}
					type="button"
				>
					<img
						src={posterSrc}
						alt={posterAlt}
						width={1280}
						height={720}
						loading="lazy"
						decoding="async"
						className="w-full rounded-lg object-cover"
					/>
					<span className="absolute top-0 left-0 h-full w-full">
						<span className="flex h-full w-full items-center justify-center">
							<span className="transform opacity-70 transition-all group-hover:opacity-100 group-focus:opacity-100 motion-safe:group-hover:scale-110 motion-safe:group-focus:scale-110 motion-safe:group-active:scale-125">
								<PlayIcon />
							</span>
						</span>
					</span>
				</button>
			)}
		</>
	)
}

export { FullScreenVideoEmbed }
